import { getRegularHoursForMonth, isSunday } from './monthUtils';
import { roundMoney, toNumber } from './obracunFields';

export function makeDateKey(year, month, day) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function getHoursFromMetricRow(m = {}) {
  const glovoH = m.glovoHours ?? m.actualWorkingHours ?? 0;
  const woltH = m.woltHours ?? m.plannedWorkingHours ?? 0;
  return toNumber(glovoH) + toNumber(woltH);
}

export function computeMonthlyHourSummary(
  userId,
  year,
  month,
  dailyMetricsData = [],
  holidaysByDate = {},
  monthlyNightHoursMap = {}
) {
  const personMetrics = dailyMetricsData.filter(
    (d) => d.userId === userId && d.year === year && d.month === month
  );

  let totalHours = 0;
  let sundayHours = 0;
  let holidayHours = 0;
  personMetrics.forEach((d) => {
    const h = getHoursFromMetricRow(d);
    totalHours += h;
    if (isSunday(year, month, d.day)) sundayHours += h;
    if (holidaysByDate[makeDateKey(year, month, d.day)]) holidayHours += h;
  });

  const regularHours = getRegularHoursForMonth(year, month);
  const overtimeHours = Math.max(0, totalHours - regularHours);
  const nightHours = toNumber(monthlyNightHoursMap?.[`${userId}_${month}`]);

  return {
    totalHours,
    regularHours,
    sundayHours,
    holidayHours,
    overtimeHours,
    nightHours,
  };
}

/** Iznosi u € iz sati × stopa — u Excelu se odbijaju kao SUNDAY, NIGHT, HOLYDAY, EXTRA HOURS */
export function computeAutoAdditionsFromHours(summary, rates = {}) {
  const sundayRate = toNumber(rates.sunday);
  const holidayRate = toNumber(rates.holiday);
  const overtimeRate = toNumber(rates.overtime);
  const nightRate = toNumber(rates.night);

  const sunday = summary.sundayHours * sundayRate;
  const holiday = summary.holidayHours * holidayRate;
  const overtime = summary.overtimeHours * overtimeRate;
  const night = summary.nightHours * nightRate;

  return {
    sunday: roundMoney(sunday),
    holiday: roundMoney(holiday),
    overtime: roundMoney(overtime),
    night: roundMoney(night),
  };
}

export function computeFeeTotals(zaradaTotal, feePercent) {
  const feeIznos = roundMoney((toNumber(zaradaTotal) * toNumber(feePercent)) / 100);
  const total1 = roundMoney(toNumber(zaradaTotal) - feeIznos);
  return { feeIznos, total1 };
}

export function computeTotal2({
  total1 = 0,
  tax = 0,
  rent = 0,
  petrol = 0,
  acom = 0,
  utility = 0,
  sim = 0,
  advance = 0,
  sunday = 0,
  holiday = 0,
  overtime = 0,
  night = 0,
  bonus = 0,
  ostalo = 0,
}) {
  const fixedDeductions =
    toNumber(tax) +
    toNumber(rent) +
    toNumber(petrol) +
    toNumber(acom) +
    toNumber(utility) +
    toNumber(sim) +
    toNumber(advance);

  const autoFromHours =
    toNumber(sunday) +
    toNumber(holiday) +
    toNumber(overtime) +
    toNumber(night);

  const additions = toNumber(bonus) + toNumber(ostalo);

  // NETO (Excel): total1 − tax − rent − … − sunday − night − holiday − overtime + bonus + ostalo
  return roundMoney(
    toNumber(total1) - fixedDeductions - autoFromHours + additions
  );
}

